import {SimpleDialogData} from '../../components/simple-dialog/simple-dialog.component';

export const sessionExpiredDialog = (): SimpleDialogData => ({
  okButton: 'Continuar',
  title: 'Faça login novamente',
  content: 'Por segurança, sua sessão é encerrada após 24 horas. Confirme seus dados para continuar.'
});
